import React, { useState } from "react";
import SectionTitle from "../../components/SectionTitle";
import axios from "axios";
import { FaLocationDot, FaPhone } from "react-icons/fa6";
import { IoIosMail } from "react-icons/io";
import { ContactContainer, ContactDetails, ContactStyled, Detail, DetailContainer, Form, FormContainer, Input, InputContainer, Status, TextArea } from "./styles";



function Contact() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [subject, setSubject] = useState("");
  const [sent, setSent] = useState(false);

  const resetForm = () => {
    setName("");
    setEmail("");
    setMessage("");
    setSubject("");
  };

  const handleSubmit = async (e) => {
    let data = {
      name: name,
      email: email,
      message: message,
      subject: subject,
    };
    await axios
      .post("https://hills-portfolio-backend.herokuapp.com/api/contact", data)
      .then((res) => {
        setSent(true);

        setTimeout(() => {
          setSent(false);
        }, 3000);
      }, resetForm())
      .catch(() => {
        console.log("message not sent");
      });
  };
  return (
    <ContactStyled id="contact">
      <SectionTitle text="Contact" />
      <ContactContainer>
        <Form>
          <FormContainer>
            <InputContainer>
              <Input
                type="text"
                placeholder="fullname"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </InputContainer>
            <InputContainer>
              <Input
                type="email"
                placeholder="example@email.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </InputContainer>
            <InputContainer>
              <Input
                type="text"
                placeholder="subject"
                value={subject}
                onChange={(e) => setSubject(e.target.value)}
              />
            </InputContainer>

            <InputContainer>
              <TextArea
                placeholder="message"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
              />
            </InputContainer>
            <InputContainer>
              <Input type="submit" value="Send" onClick={handleSubmit} />
            </InputContainer>
          </FormContainer>
          {sent && <Status>Message Sent </Status>}
        </Form>
        <ContactDetails>
          <Detail>
            <DetailContainer>
              <FaPhone />
              <span>+2347044377963</span>
            </DetailContainer>
          </Detail>
          <Detail>
            <DetailContainer>
              <IoIosMail />
              <span>ekwealorhillary@gmail.com</span>
            </DetailContainer>
          </Detail>
          <Detail>
            <DetailContainer>
              <FaLocationDot />
              <span>No 49d Onyebuchi Street Nsukka Enugu State Nigeria</span>
            </DetailContainer>
          </Detail>
        </ContactDetails>
      </ContactContainer>
    </ContactStyled>
  );
}

export default Contact;
